module.exports = __webpack_public_path__ + "static/media/logout.336a1645.svg";